import { Injectable } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { tap, map, catchError, finalize } from "rxjs/operators";
import { AlertService } from '../Services/alert-service/alert-service.service';
import { ExceptionModel, RouterConstants } from '../Models/app-data';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';


@Injectable()
export class CustomInterceptor {

    constructor(public loaderService: NgxSpinnerService, private alertSrv: AlertService, private _router: Router) { }

    //#region Global Variables
    count: number = 0;
    exceptionModel: ExceptionModel;
    routerConstants = RouterConstants;
    //#endregion

    //function which will be called for all http calls
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {

        this.count++;
        if (this.count == 1) {
            setTimeout(() => {
                this.loaderService.show();
            }, 100);
        }

        return next.handle(request).pipe(
            tap(res => {
                if (res instanceof HttpResponse) {
                    this.count--;
                    return event;
                }
            }),
            catchError(error => {
                this.count--;
                if (error.status === 403) {
                    this.count = 0;
                    Swal.fire({
                        title: 'Access Denied !!',
                        text: error.error,
                        allowEscapeKey: false,
                        icon: 'warning',
                        backdrop: true,
                        allowOutsideClick: false
                    }).then((result) => {
                        if (result.value)
                            this._router.navigate(['/' + this.routerConstants.Error]);
                    })
                }
                else {
                    this.exceptionModel = error.error;
                    const message = error.error ? (error.error.Message ? error.error.Message : error.error)
                        : error.message ? error.message
                            : error.toString();
                    this.alertSrv.showError((this.exceptionModel.ExceptionTitle != "" ? this.exceptionModel.ExceptionTitle : error.statusText), this.exceptionModel.ExceptionMessage, "OK");
                }
                return throwError(error);
            }),
            finalize(() => {
                // Hide loader here
                if (this.count == 0) {
                    setTimeout(() => {
                        this.loaderService.hide();
                    }, 100);
                }
            })
        );
    }

}
